export const LOCAL = 'local'
export const PROTO0 = 'proto0'
export const STAGING = 'staging'
export const PROD = 'prod'
